var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1982",
    "data-name": "Rectangle 1982",
    width: 52,
    height: 52,
    transform: "translate(1242 1845)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_44",
    "data-name": "Mask Group 44",
    transform: "translate(-1242 -1845)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "redis",
    transform: "translate(1242 1848.681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19845",
    "data-name": "Path 19845",
    d: "M49.963,34.317c-2.775,1.446-17.151,7.357-20.211,8.953s-4.761,1.58-7.178.425S4.857,36.359,2.1,35.041C.724,34.383,0,33.827,0,33.3V28.046s19.916-4.336,23.132-5.489,4.331-1.2,7.067-.193S49.3,26.319,52,27.309v5.182c0,.52-.624,1.09-2.036,1.826",
    fill: "#912626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19846",
    "data-name": "Path 19846",
    d: "M49.962,29.092c-2.775,1.446-17.15,7.357-20.211,8.952s-4.76,1.58-7.178.425S4.858,31.133,2.1,29.816-.711,27.592,2,26.533,19.916,19.5,23.132,18.35s4.33-1.2,7.067-.193,17.026,6.69,19.73,7.68,2.809,1.808.034,3.254",
    fill: "#c6302b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19847",
    "data-name": "Path 19847",
    d: "M49.963,25.812c-2.775,1.447-17.151,7.357-20.211,8.953s-4.761,1.58-7.178.424S4.857,27.854,2.1,26.537C.724,25.879,0,25.324,0,24.8V19.542s19.916-4.335,23.132-5.489,4.331-1.2,7.067-.193S49.3,17.813,52,18.8v5.182c0,.519-.624,1.089-2.036,1.825",
    fill: "#912626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19848",
    "data-name": "Path 19848",
    d: "M49.962,20.587c-2.775,1.446-17.15,7.357-20.211,8.953s-4.76,1.58-7.178.424S4.858,22.628,2.1,21.312-.711,19.088,2,18.028,19.916,11,23.132,9.845s4.33-1.2,7.067-.193,17.026,6.69,19.73,7.68,2.809,1.808.034,3.254",
    fill: "#c6302b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19849",
    "data-name": "Path 19849",
    d: "M49.963,16.992c-2.775,1.446-17.151,7.357-20.211,8.953s-4.761,1.58-7.178.424S4.857,19.034,2.1,17.717C.724,17.058,0,16.5,0,15.979V10.722S19.916,6.387,23.132,5.233s4.331-1.2,7.067-.193S49.3,8.994,52,9.985v5.182c0,.519-.624,1.089-2.036,1.825",
    fill: "#912626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19850",
    "data-name": "Path 19850",
    d: "M49.962,11.767c-2.775,1.446-17.15,7.357-20.211,8.953s-4.76,1.58-7.178.425S4.858,13.808,2.1,12.492-.711,10.268,2,9.208,19.916,2.18,23.132,1.026,27.462-.169,30.2.833s17.026,6.69,19.73,7.68,2.809,1.807.034,3.253",
    fill: "#c6302b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19851",
    "data-name": "Path 19851",
    d: "M32.354,6.654l-4.471.464-1,2.408L25.266,6.839,20.1,6.375l3.852-1.389L22.8,2.853l3.606,1.41,3.4-1.113-.919,2.2,3.467,1.3M26.616,18.337l-8.344-3.461,11.956-1.835-3.612,5.3M15.048,7.992c3.529,0,6.39,1.109,6.39,2.477s-2.861,2.477-6.39,2.477-6.39-1.109-6.39-2.477,2.861-2.477,6.39-2.477",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19852",
    "data-name": "Path 19852",
    d: "M37.638,7.312l7.076,2.8L37.644,12.9l-.006-5.59",
    fill: "#621b1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19853",
    "data-name": "Path 19853",
    d: "M29.81,10.409l7.828-3.1.006,5.59-.768.3L29.81,10.409",
    fill: "#9a2928"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedis);
export default __webpack_public_path__ + "static/media/Redis.dadf62d284f055ed0649f41e5293de2c.svg";
export { ForwardRef as ReactComponent };